module.exports = __webpack_public_path__ + "static/media/Yeongwol4.ebaa5a38.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Yeongwol4.jpeg
// module id = 586
// module chunks = 0